import { Model } from '@shared/models/model';
import { Truck } from './truck.model';
import { Expose } from 'class-transformer';
import { Driver } from './driver.model';

export class PermittedDriversAndTrucks extends Model{
  @Expose() trucks: Truck[];
  @Expose() drivers: Driver[];
}
